module.exports = __webpack_public_path__ + "img/astasks.3c3723a1.png";